import { createAction, props } from '@ngrx/store';
import { AssetWithUsersV26 } from 'src/app/models-v26/asset-with-users-v26';
import { ActionResponse } from 'src/app/models/action-response';
import { SwapContractInitStepV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/swap-contract-wizard/init-step/swap-contract-init-step';
import { NewSwapAssetRequestV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/swap-contract-wizard/summary-step/new-swap-asset-request';

export const selectSwapContractInitStep = createAction(
  '[V26 User Property Panel] Select Swap Contract Init Information Step',
  props<{ initStep: SwapContractInitStepV26 }>(),
);

export const selectAssetTobeCancelledStep = createAction(
  '[V26 Wizard License Product Step] Select License Product Information Step',
  props<{ assetTobeCancelledStep: AssetWithUsersV26 }>(),
);

export const validateSwapRequest = createAction(
  '[V26 Wizard Confirmation Step] Validate Swap Contract Step',
  props<{ request: NewSwapAssetRequestV26 }>(),
);

export const validateSwapRequestResult = createAction(
  '[V26 Wizard Confirmation Step] Validate Swap Contract Step Result',
  props<{ response: ActionResponse }>(),
);

export const validateSwapRequestFail = createAction(
  '[V26 Wizard Confirmation Step] Validate Swap Contract Step Fail',
  props<{ errorMessage: string }>(),
);

export const exitAllocationSwapContractWizard = createAction('[V26 Cancel Wizard Page] Exit Swap Contract Wizard');

export const destroyWizard = createAction('[V26 Swap Contract Wizard Page] Exit Destroy Wizard');

export const createNewOrder = createAction(
  '[V26 Wizard Confirmation Step] Create Swap Contract Step',
  props<{ newOrder: NewSwapAssetRequestV26 }>(),
);

export const createNewOrderSuccess = createAction(
  '[V26 Wizard Confirmation Step] Create Swap Contract Step Success',
  props<{ response: ActionResponse }>(),
);

export const createNewOrderFail = createAction(
  '[V26 Wizard Confirmation Step] Create Swap Contract Step Fail',
  props<{ errorMessage: string }>(),
);
